import { createFlashMessage } from '@components/Flash/redux';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getDeletedUsers, getRequestedToDeleteUsers } from '@utils/api/admin';
import { actionTypes } from './action-types';

function* fetchRequestedToDeleteUsersSaga({ payload }) {
  try {
    const data = yield call(getRequestedToDeleteUsers, {
      filter: payload
    });

    if (data.success) {
      yield put({
        type: actionTypes.fetchRequestToDeleteUsersComplete,
        payload: data
      });
    }
  } catch (error) {
    yield put(
      createFlashMessage({
        type: 'danger',
        message:
          error?.message || 'Indisponível, tente novamente em alguns minutos.',
        variables: { dismissible: true }
      })
    );
  }
}

function* fetchDeletedUsersSaga({ payload }) {
  try {
    const data = yield call(getDeletedUsers, {
      filter: payload
    });

    if (data.success) {
      yield put({
        type: actionTypes.fetchDeletedUsersComplete,
        payload: data
      });
    }
  } catch (error) {
    yield put(
      createFlashMessage({
        type: 'danger',
        message:
          error?.message || 'Indisponível, tente novamente em alguns minutos.',
        variables: { dismissible: true }
      })
    );
  }
}

export function createUsersDeleteSaga(types) {
  return [
    takeLatest(
      types.fetchRequestToDeleteUsers,
      fetchRequestedToDeleteUsersSaga
    ),
    takeLatest(types.fetchDeletedUsers, fetchDeletedUsersSaga)
  ];
}
